"use client";

import * as React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Calendar, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
const litters = [{
  id: 1,
  season: "Fall 2026",
  title: <><span className="!text-left">GCH Cobrnik All The Way "Lou"</span></>,
  description: "Retired show girl looking for snuggles and a nice family to love.\xA0 DOB 6/27/2023",
  imageSrc: "https://cobrnik.com/wp-content/uploads/2026/10/Maya-head-shot-scaled.jpg?v=7adqw3b2l4s",
  imageSrcset: "https://cobrnik.com/wp-content/uploads/2026/09/Lou-head-shot.png?v=asmwzimh7sa-wvc-srcset",
  imageSizes: "https://cobrnik.com/wp-content/uploads/2026/09/Lou-head-shot.png?v=13trsptm3jq-wvc-sizes",
  imageAlt: "Cavalier King Charles Spaniel puppy resting comfortably on a soft lilac blanket",
  badge: "Retired",
  link: "/ContactApplicationPage"
}];
export default function Litters() {
  const shouldReduceMotion = useReducedMotion();
  return;
}